var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4130_34894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4130_34894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 36.0266C25.7329 36.0266 25.4788 35.9766 25.2371 35.8766C24.9954 35.7766 24.7746 35.6349 24.5746 35.4516L16.5496 27.4266C16.3663 27.2266 16.2246 27.0057 16.1246 26.7641C16.0246 26.5224 15.9746 26.2682 15.9746 26.0016C15.9746 25.7349 16.0246 25.4766 16.1246 25.2266C16.2246 24.9766 16.3663 24.7599 16.5496 24.5766L24.5746 16.5516C24.7746 16.3516 24.9954 16.2057 25.2371 16.1141C25.4788 16.0224 25.7329 15.9766 25.9996 15.9766C26.2663 15.9766 26.5246 16.0224 26.7746 16.1141C27.0246 16.2057 27.2413 16.3516 27.4246 16.5516L35.4496 24.5766C35.6496 24.7599 35.7954 24.9766 35.8871 25.2266C35.9788 25.4766 36.0246 25.7349 36.0246 26.0016C36.0246 26.2682 35.9788 26.5224 35.8871 26.7641C35.7954 27.0057 35.6496 27.2266 35.4496 27.4266L27.4246 35.4516C27.2413 35.6349 27.0246 35.7766 26.7746 35.8766C26.5246 35.9766 26.2663 36.0266 25.9996 36.0266ZM25.9996 34.0266L34.0246 26.0016L25.9996 17.9766L17.9746 26.0016L25.9996 34.0266ZM24.9996 27.0016H26.9996V21.0016H24.9996V27.0016ZM25.9996 30.0016C26.2829 30.0016 26.5204 29.9057 26.7121 29.7141C26.9038 29.5224 26.9996 29.2849 26.9996 29.0016C26.9996 28.7182 26.9038 28.4807 26.7121 28.2891C26.5204 28.0974 26.2829 28.0016 25.9996 28.0016C25.7163 28.0016 25.4788 28.0974 25.2871 28.2891C25.0954 28.4807 24.9996 28.7182 24.9996 29.0016C24.9996 29.2849 25.0954 29.5224 25.2871 29.7141C25.4788 29.9057 25.7163 30.0016 25.9996 30.0016Z",
    fill: "#008685"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.70b41dcaf6637fb9573a5a1054972ea2.svg";
export { ForwardRef as ReactComponent };